import React from "react";
import gsap from "gsap";
import "./css/portfolio.css";
import RotatingCircle from "./rotatingcircle";
// import nighticon from "./assets/nighticon.png";
import roundflow3 from "./assets/roundflow3.svg";
import Personalimage from "./personalimage";
import MainContentAnimations from "./maincontentAnimation";
// import Loader from "./loader";
import Notification from "./notification";
import SvgContainer from "./smallScreenImageSvg";
import CursorTrail from "./cursortrail";
import DrawingCanvas from "./drawingCanvas";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
// import transition from "./transition";

const MainContent = () => {
  const openSvg = () => {
    gsap.to(".svg-container", {
      scale: 1,
      opacity: 1,
      duration: 0.5,
      display: "block",
    });
  };

  // useEffect(() => {
  //   // Check if the page is being loaded for the first time
  //   const isFirstLoad = localStorage.getItem("isFirstLoad");

  //   if (isFirstLoad || location.state?.from !== "navigation") {
  //     // Hide loader after animation duration
  //     setTimeout(() => {
  //       setIsLoading(false);
  //     }, 10000); // Adjust the duration as needed (in milliseconds)

  //     // Set isFirstLoad in local storage
  //     localStorage.setItem("isFirstLoad", "true");
  //   }
  // }, [location.state]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container">
        {/* {isLoading && <Loader />} */}

        {/* Main content animations */}
        <MainContentAnimations />
        <Notification />
        <SvgContainer openSvg={openSvg} />
        <div className="main">
          <div className="col col-1">
            <div className="logo">
              <p>
                <b>Broseey</b>
              </p>
            </div>
            <div className="year">
              <p>2020-2023</p>
              <object
                className="svg-class"
                type="image/svg+xml"
                data={roundflow3}
              >
                Your browser does not support SVG
              </object>
            </div>
          </div>

          <div className="col col-2">
            <div className="mydetail">
              <p>
                The ability to create aesthetic stuff feels like a kinda
                superpower at least for{" "}
                <span
                  id="toggleButton"
                  style={{
                    zIndex: 999,
                    pointerEvents: "all",
                    fontWeight: "bolder",
                    cursor: "pointer",
                  }}
                  onClick={openSvg}
                >
                  <u>Broseey</u>
                </span>
                <span className="showText">Broseey</span>. <br />
                He takes the UI/UX designer's code and gives an amazing fix to
                it, making it even more visually pleasing for the User as the
                User flows through the webpage. <br />
                Make no mistake He is no Designer, even if he has a good rapport
                with the designer's Figma, rather He is a CREATIVE FRONTEND
                DEVELOPER!
              </p>
              <br />
              <br />
              <p>
                <u>Niche</u>
              </p>
              <p>
                Modern Web Development, Aesthetics,
                <br /> Frontend, Greensock Animation, Animations,
                <br /> Minimalism, Visual Development,code
              </p>
              <br />
              <br />
              <p>
                <u>Contact</u>
              </p>
              <p>
                <a href="mailto:ambroseothniel1@gmail.com">
                  <b>Gmail</b>
                </a>
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/ambrose-othniel/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>LinkedIn</b>
                </a>
              </p>
              <p>
                <a
                  href="https://github.com/Broseey"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Github</b>
                </a>
              </p>
              <p>
                <Link
                  style={{ border: "1px groove black", fontWeight: "bolder" }}
                  to="/resume"
                >
                  View Resume
                </Link>
              </p>
            </div>
            <div>
              <p id="copyrights">copyright &copy; All rights reserved.</p>
            </div>
          </div>
        </div>

        <div className="btn-outline btn-outline-1">
          <p id="menu" className="hover-this">
            <b>
              <Link to="/projectPage">VIEW PROJECTS</Link>
            </b>
          </p>
          <CursorTrail />
        </div>

        <div className="btn-outline btn-outline-2"></div>

        <RotatingCircle />

        <div className="side-menu">
          <div className="side-menu-projects">
            <p>
              <a
                href="https://broseey.github.io/fun-projects-hub/"
                title="subtle fun parts of my projects"
                target="_blank"
                rel="noopener noreferrer"
              >
                Code-prep
              </a>
            </p>
          </div>
        </div>

        <Personalimage />
      </div>
      <DrawingCanvas />
    </motion.div>
  );
};

export default MainContent;
